import { createAction } from '@reduxjs/toolkit';

import { ProductUrlType } from 'src/types';

interface ProductClickPayload {
  destinationUrl: ProductUrlType;
  productUrl: ProductUrlType;
  productCode: number;
}

export const onProductClick = createAction<ProductClickPayload>('products/clickProductImpression');
